<template>
  <modal width="100%" height="auto" class="gallery" :scrollable="true" :class="{'active':isVisible}" name="gallery" @before-open="beforeOpen" @before-close="beforeClose">
    <div v-if="isVisible" class="gallery__wrapper">
      <div class="gallery__info">
        <div v-if="isVisible" slot="top-right" class="d-none d-lg-block">
          <div class="gallery__close d-none d-lg-flex" @click="closeModal"><Cross /></div>
        </div>
        <h3 class="gallery__info-title d-none d-lg-flex">{{ title }}</h3>
        <p class="gallery__info-price-text d-none d-lg-block" v-html="priceText" />
        <section class="gallery__info-facilities d-none d-md-flex">
          <div v-if="bedType" class="facility">
            <p class="facility-label">Bed type</p>
            <p class="facility-value">{{ bedType }}</p>
          </div>
          <div v-if="maximumCapacity" class="facility">
            <p class="facility-label">Occupancy</p>
            <p class="facility-value">{{ maximumCapacity }} people</p>
          </div>
          <div v-if="roomSize" class="facility">
            <p class="facility-label">Room Size</p>
            <p class="facility-value">{{ roomSize }}</p>
          </div>
        </section>
        <section v-if="isVisible" class="gallery__info-desc">
          <section class="gallery__info-desc-text" v-html="description" />
          <section v-if="isVisible" class="gallery__info-buttons">
            <button class="book_button btn--dark-green" @click="openStay">{{ ctaLabel }}</button>
            <!-- <a class="external_button btn--white" href="">view 360 room</a> -->
          </section>
        </section>
        <div v-if="isVisible && floorPlan && floorPlan.image" class="gallery__info-floorplan">
          <p class="title">
            {{ floorPlan.title || 'Floorplan' }}
          </p>
          <p class="label">{{ floorPlan.label }}</p>
          <KenticoImage v-if="floorPlan.image.url" class="image" :src="floorPlan.image.url" />
        </div>
      </div>
      <section v-if="isVisible" class="gallery__info-facilities d-md-none">
        <div v-if="bedType" class="facility">
          <p class="facility-label">Bed type</p>
          <p class="facility-value">{{ bedType }}</p>
        </div>
        <div v-if="maximumCapacity" class="facility">
          <p class="facility-label">Occupancy</p>
          <p class="facility-value">{{ maximumCapacity }} people</p>
        </div>
        <div v-if="roomSize" class="facility">
          <p class="facility-label">Room Size</p>
          <p class="facility-value">{{ roomSize }}</p>
        </div>
      </section>

      <div v-if="isVisible" class="gallery__viewer">
        <div class="gallery__row">
          <div class="np--all">
            <div ref="slider" v-swiper:mySwiper="swiperOption" class="simple-slider">
              <div class="swiper-wrapper">
                <div v-for="(image, index) in images" :key="index" class="swiper-slide simple-slider__item">
                  <KenticoResponsiveImage :alt="image.description" :src="image.url" class="simple-slider__image" :sizes="imageSizes" />
                </div>
              </div>
              <div slot="button-next" class="swiper-button swiper-button-next"><Chevron /></div>
              <div slot="button-prev" class="swiper-button swiper-button-prev"><Chevron /></div>
              <div class="gallery__control">
                <ul class="gallery__progress">
                  <li
                      v-for="(dot, index) in images"
                      :key="index"
                      :class="{ active: currentSection >= index + 1 }"
                      class="gallery__progress-item"
                      @click="goToSection(index + 1)"
                  />
                </ul>
              </div>
            </div>
          </div>
          <div class="np--all"><slot name="details" /></div>
        </div>
      </div>
      <div class="gallery__info d-lg-none mobile">
        <h3 class="gallery__info-title">{{ title }}</h3>
        <p class="gallery__info-price-text" v-html="priceText" />
        <div>
          <div class="gallery__close" @click="closeModal"><Cross /></div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Cross from '~/assets/icons/close-modal.svg?inline';
import { BREAKPOINTS, BREAKPOINT_LG } from '~/utils/constants';
import pascalCase from 'pascal-case';
import { viewedCarousel } from '~/utils/gtm-events.js';

export default {
  name: 'Gallery',
  components: {
    Cross,
  },
  data() {
    return {
      images: [],
      title: '',
      ctaLink: '',
      ctaLabel: '',
      maximumCapacity: '',
      priceText: '',
      currentSection: 1,
      description: '',
      selectedRoom: {},
      floorPlan: {},
      roomSize: '',
      bedType: '',
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          slideChange: () => {
            this.currentSection = this.$refs.slider ? this.$refs.slider.swiper.realIndex + 1 : 1;

            // if slide has a name, use that, otherwise just use 'image{index}' as name
            const imageTitle = this.images[this.currentSection - 1].name ? this.images[this.currentSection - 1].name : `image${this.currentSection}`;
            const pascalRoom = pascalCase(this.title.toLowerCase());
            viewedCarousel(this.$gtm, pascalRoom, imageTitle, this.currentSection, this.images.length );
          },
        },
      },
      imageSizes: {
        default: [900, 750],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 1200, height: 1000 },
        ],
      },
      isVisible: false,
    };
  },
  methods: {
    openStay() {
      if (this.ctaLink) {
        window.location = this.ctaLink;
      } else {
        const { location, bookingType } = this;

        this.$modal.hide('gallery');
        this.$modal.show('booking', {
          location: location.location || '',
          bookingType,
        });
      }
    },
    beforeOpen(event) {
      this.images = event.params.images || '';
      this.title = event.params.title || '';
      this.isVisible = event.params.isVisible || '';


      this.facilities = event.params.facilities || [];
      this.maximumCapacity = event.params.maximumCapacity || '';
      this.longStayPriceText = event.params.longStayPriceText || '';
      this.bookingType = event.params.bookingType || '';
      this.ctaLabel = event.params.ctaLabel || 'Book';
      this.ctaLink = event.params.ctaLink || '';
      this.description = event.params.description || '';
      this.billsIncludedText = event.params.billsIncludedText || '';
      this.floorPlan = event.params.floorPlan || {};
      this.priceText = event.params.priceText || '';
      this.prices = event.params.prices || '';
      this.location = event.params.location || '';
      document.documentElement.style.overflow = 'hidden';
      this.roomSize = (this.facilities.filter((facility) => facility.contentCodename === 'room_size' || facility.contentCodename === 'n245_ft2___23m2') [0] || {}).title;
      this.bedType = (this.facilities.filter((facility) =>facility.contentCodename.indexOf('bed') >= 0) [0] || {}).title;
    },
    beforeClose(event) {
      this.isVisible = false;
      document.documentElement.style.overflow = 'auto';
    },
    closeModal() {
      document.documentElement.style.overflow = 'auto';
      this.$modal.hide('gallery');
    },
    goToSection(section) {
      this.mySwiper.slideTo(section);
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_gallery.scss';
</style>
